import React from 'react';
import { Grid } from '@material-ui/core';
import Typography from '../../../components/atoms/Typography';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import RichText from '../../../components/atoms/RichText';
import { get } from 'lodash';
import useStyles from './style';
const Heading = (props) => {
  const classes = useStyles();
  const { sitecoreContext } = props
  const name = get(sitecoreContext, 'route.fields.name', '');
  return (
    <Grid>
      {name &&
        <Typography
          variant="h2"
          component="h2"
          animateSettings={{
            willAnimate: false,
          }}
        >
          <RichText
            innerHTML={name}
            className={classes.richTextOverride}
          />
        </Typography>}
    </Grid>
  )
};

export default withSitecoreContext()(Heading);
